import { useState } from "react";
import { Col, Row, Switch } from "antd";
import Form from "antd/lib/form/Form";
import { useHistory } from "react-router-dom";
import AppIcon from "../../../assets/images/icon.svg";
import Button from "../../../component/Button";
import Input from "../../../component/Input";
import EmailLinkSent from "./EmailLinkSent";
import LoginSvg from "../../../assets/icons/login-icon.svg";
import { QuestionCircleOutlined } from '@ant-design/icons';

const RequestOTP = () => {
    const history = useHistory();
    const [isLoginSuccessful, setIsLoginSuccessful] = useState(false);

    return isLoginSuccessful 
        ? <EmailLinkSent 
            setIsLoginSuccessful={setIsLoginSuccessful} 
        /> 
        : (
        <>
            <Col xs={0} md={12}>
                <div className="left-pane">
                    <img className="app-logo" src={AppIcon} alt="logo" />
                    <div className="align-center">
                        <img src={LoginSvg} alt="icon" />
                        <h3>Welcome back</h3>
                        <p>Enter your details to log into your account</p>
                    </div>
                </div>
            </Col>
            <Col xs={24} md={12}>
                <div className="right-pane">
                    <span className="close-icon" onClick={() => history.goBack()}>
                        <i className="lni lni-arrow-left" /> Back
                    </span>
                    <Form
                        name="basic"
                        layout="vertical"
                        requiredMark={false}
                        onFinish={() => setIsLoginSuccessful(true)}
                    >
                        <Row gutter={24} align="middle">
                            <Col span={24}>
                                <Input
                                    formItem={{
                                        label: "What is your phone number?",
                                        name: "phone",
                                        rules: [
                                            { required: true, message: 'Please input your phone number' }
                                        ],
                                        tooltip: { title: 'Enter your phone number', icon: <QuestionCircleOutlined /> }
                                    }}
                                    placeholder="08012345678"
                                    type="phone"
                                    className="phone-input"
                                    marginBottom={0}
                                    label="What is your phone number?"
                                />
                                <div className="phone-switch">
                                    <Switch defaultChecked /> 
                                    <span>Use phone number instead</span>
                                </div>
                            </Col>
                            <Col span={24} className="align-center">
                                <Button htmlType="submit" type="primary" className="auth-button login-button">Request OTP</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Col>
        </>
    )
}

export default RequestOTP;